import { Component, ElementRef, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DialogService } from 'primeng/dynamicdialog';
import { fromEvent, Subject, Subscription } from 'rxjs';
import { debounceTime, filter, map, takeUntil } from 'rxjs/operators';
import { BuildVisaDesignerComponent } from '../build-visa-designer/build-visa-designer.component';
import { VisaDesignerService } from '../visa-designer.service';

@Component({
  selector: 'app-vd-container',
  templateUrl: './vd-container.component.html',
  styleUrls: ['./vd-container.component.scss'],
  providers: [DialogService]
})
export class VdContainerComponent implements OnInit, OnDestroy {
  toggleStatus = 'CREATED';
  observableSubscription$ = new Subject();
  searchSubscription: Subscription;
  @ViewChild('searchVisa', { static: true }) searchVisa: ElementRef;
  listCountry = [];
  formTypeArr: {
    createdBy: number; modifiedBy: any; id: number; group: string; refGroupdesc: string;
    code: string; name: string; description: string;
  }[] = [];
  visaTypeArr: {
    createdBy: number; modifiedBy: any; id: number; group: string; refGroupdesc: string;
    code: string; name: string; description: string;
  }[] = [];
  petitionTypeArr: {
    createdBy: number; modifiedBy: any; id: number; group: string; refGroupdesc: string;
    code: string; name: string; description: string;
  }[] = [];
  filter = {
    countryCode: '',
    formType: '',
    visaType: '',
    petitionType: '',
    immCategoryCode: '',
    immClassificationCode: ''
  };
  searchText: string;
  visaAndPetitionTypeArr: any[] = [];
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private vdService: VisaDesignerService,
    public dialogService: DialogService) { }

  ngOnInit(): void {
    this.vdService.getCountryList().pipe(takeUntil(this.observableSubscription$)).subscribe((response: any) => {
      this.listCountry = response.data && response.data.length > 0 ? response.data : [];
    });

    this.vdService.getLanguageAndFormType('USA').pipe(takeUntil(this.observableSubscription$)).subscribe((response: any) => {
      this.formTypeArr = response.data && response.data.formType && response.data.formType.length > 0 ? response.data.formType : [];
    });

    this.searchSetUp();
  }

  handleChange() {

    if (this.filter.countryCode && this.filter.formType) {
      const payload = {
        countryCode: this.filter.countryCode,
        formType: this.filter.formType
      };
      this.visaTypeArr = [];
      this.visaAndPetitionTypeArr = [];
      this.vdService.getAllDependentDataByFormType(payload).pipe(takeUntil(this.observableSubscription$)).subscribe((response: any) => {
        if (this.filter.formType === 'I589FORM') {
          this.visaAndPetitionTypeArr =
            response.data && response.data.immigratioCatAndClassType &&
              response.data.immigratioCatAndClassType.length > 0 ?
              response.data.immigratioCatAndClassType : [];
          this.visaTypeArr = this.visaAndPetitionTypeArr.map(x => x.immigrationCategory);

        } else {
          this.visaAndPetitionTypeArr =
            response.data && response.data.allVisaAndPetitionType &&
              response.data.allVisaAndPetitionType.length > 0 ?
              response.data.allVisaAndPetitionType : [];
          this.visaTypeArr = this.visaAndPetitionTypeArr.map(x => x.visaType);
        }

        //this.visaTypeArr = response.data && response.data.visaType && response.data.visaType.length > 0 ? response.data.visaType : [];
        //this.petitionTypeArr = response.data && response.data.petitionType && response.data.petitionType.length > 0 ? response.data.petitionType : [];
      });
    }
  }

  handleVisaTypeChange() {
    this.petitionTypeArr = [];
    if (this.filter.formType === 'I589FORM') {
      // this.visaAndPetitionTypeArr = response.data && response.data.immigratioCatAndClassType && response.data.immigratioCatAndClassType.length > 0 ? response.data.immigratioCatAndClassType:[];
      // this.visaTypeArr = this.visaAndPetitionTypeArr.map(x => x.immigrationCategory);
      const tempArr = this.visaAndPetitionTypeArr.find(item => item.immigrationCategory.code === this.filter.immCategoryCode);
      this.petitionTypeArr = tempArr ? tempArr.immigrationClassType : [];

    } else {
      const tempArr = this.visaAndPetitionTypeArr.find(item => item.visaType.code === this.filter.visaType);
      this.petitionTypeArr = tempArr ? tempArr.petitionType : [];
    }

  }

  buildNewVisa() {
    const ref = this.dialogService.open(BuildVisaDesignerComponent, {
      header: 'Options to create form',
      width: '70%',
      styleClass: 'build-new-visa-popup'
    });

    ref.onClose.subscribe((proceed: boolean) => {
      if (proceed) {
        this.router.navigate(['../visa-builder/create-visa/new'], { relativeTo: this.route });
      }
    });
  }
  toggleMode(mode) {
    if (this.toggleStatus !== mode) {
      // this.pageIndex = 0;
      // this.payload.pageNumber = 1;
      // this.payload.pageSize = 25;
    }
    this.toggleStatus = mode;
    // this.getTasks(this.toggleStatus);
  }
  searchSetUp() {
    this.searchSubscription = fromEvent(this.searchVisa.nativeElement, 'keyup').pipe(
      map((event: any) => event.target.value)
      , filter(res => res.length > 2)
      , debounceTime(1000)).subscribe((text: string) => {
        this.searchText = text.trim();
        this.emitEventToList({ searchText: this.searchText });
        // this.vdService.manageVisaFilterChanged.next({ searchText: this.searchText });
        // this.getTasks(this.toggleStatus)
      });
  }
  resetSearch() {
    this.searchText = '';
    this.emitEventToList({ searchText: this.searchText });
  }
  handleFilterChange() {
    this.emitEventToList(this.filter);

  }

  emitEventToList(val) {
    this.vdService.manageVisaFilterChanged.next(val);
  }
  filterCancel() {
    this.filter = {
      countryCode: '',
      formType: '',
      visaType: '',
      petitionType: '',
      immCategoryCode: '',
      immClassificationCode: '',

    };

    this.emitEventToList(this.filter);
  }

  ngOnDestroy() {
    this.searchSubscription.unsubscribe();
    this.observableSubscription$.next();
    this.observableSubscription$.complete();
  }
}

